import React, { Component } from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Spinner } from '../Spiner/Spiner';
import { EXERCISE_SCROLL_TYPES } from '../../../Store/ActionTypes/ExercisesActionTypes';
import { ExercisesActionCreators } from '../../../Store/ActionCreators/ExercisesActionCreators';

class InfiniteExercisesScroll extends Component {
    loadMoreAllExercises = (filter, offsetId) => {
        this.props.loadMoreAllExercises(filter, offsetId);
    };

    loadMoreExercisesByType = (key, filter, offsetId) => {
        this.props.loadMoreExercisesByType(key, filter, offsetId);
    };

    render() {
        const {
            props: {
                scrollType,
                workoutType,
                allExercisesOffsetId,
                byTypeExercisesOffsetId,
                allExercisesList,
                byTypeExercisesList,
                scrollableTarget,
                moreAllExercisesToLoad,
                moreByTypeExercisesToLoad,
                children,
                filter,
            },
            loadMoreAllExercises,
            loadMoreExercisesByType,
        } = this;

        let selectedOffsetId = allExercisesOffsetId,
            selectedSearchMethod = loadMoreAllExercises.bind(this, filter, selectedOffsetId),
            selectedDataLength = allExercisesList.length,
            hasMore = moreAllExercisesToLoad;

        switch (scrollType) {
            case EXERCISE_SCROLL_TYPES.BY_TYPE: {
                selectedOffsetId = byTypeExercisesOffsetId;
                selectedSearchMethod = loadMoreExercisesByType.bind(this, workoutType, filter, selectedOffsetId);
                selectedDataLength = byTypeExercisesList.length;
                hasMore = moreByTypeExercisesToLoad;
                break;
            }
            default:
                break;
        }

        return (
            <InfiniteScroll
                dataLength={selectedDataLength}
                next={() => selectedSearchMethod()}
                hasMore={selectedDataLength >= 50}
                loader={<Spinner />}
                scrollableTarget={scrollableTarget}
            >
                {children}
            </InfiniteScroll>
        );
    }
}

const mapStateToProps = ({
    exercises: {
        allExercises: { allExercisesList, allExercisesOffsetId, moreAllExercisesToLoad },
        byTypeExercises: { byTypeExercisesList, byTypeExercisesOffsetId, moreByTypeExercisesToLoad },
    },
}) => ({
    allExercisesList,
    allExercisesOffsetId,
    byTypeExercisesList,
    byTypeExercisesOffsetId,
    moreAllExercisesToLoad,
    moreByTypeExercisesToLoad,
});

const mapDispatchToProps = dispatch => ({
    loadMoreAllExercises: (filter, offsetId) =>
        dispatch(ExercisesActionCreators.getMoreExercisesRequest(filter, offsetId)),
    loadMoreExercisesByType: (key, filter, offsetId) =>
        dispatch(ExercisesActionCreators.getMoreExercisesByTypeRequest(key, filter, offsetId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(InfiniteExercisesScroll);



// WEBPACK FOOTER //
// ./src/UI/Components/InfiniteScroll/InfiniteExercisesScroll.js